<template>
	<div class="search-field-list-item">
		<div class="flex-centerize">
			<v-list-item-action v-if="isMultipleSelection">
				<v-checkbox :value="value"></v-checkbox>
			</v-list-item-action>
			<v-list-item-avatar v-if="item.image" size="20" class="avatar-img">
				<img :src="item.image" />
			</v-list-item-avatar>
			<v-list-item-content>
				<v-list-item-title>{{ item.option }}</v-list-item-title>
			</v-list-item-content>
		</div>
		<div class="flex-centerize" :class="{ ['description-section']: item.description }">
			<v-list-item-content v-if="item.description" class="description-container">
				<v-list-item-title class="description">{{ item.description }}</v-list-item-title>
			</v-list-item-content>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SearchFieldListItem',
	props: {
		item: { type: Object },
		value: { type: Object },
		isMultipleSelection: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.avatar-img {
	margin-right: 8px;
}
.description-section {
	padding-bottom: 4px;
	.description-container {
		padding: 0 !important;
		.description {
			font-size: small;
			color: #939293;
		}
	}
}
</style>

<style scoped lang="scss">
.search-field-list-item {
	::v-deep {
		.v-list {
			padding: 4px 0;
		}

		.v-list-item__content {
			margin: 0 !important;
			padding: 4px 0;
		}
		.v-list-item__action {
			margin: 8px 5px 8px 0 !important;
		}
		.v-input--selection-controls__input {
			height: auto;
		}
		.v-list-item__title {
			color: #4d4c52 !important;
		}
		.v-list-item--active {
			.v-list-item__title {
				color: #459ffa !important;
			}
			.v-list-item--link:before {
				background-color: #d9ecfe;
			}
		}
	}
	.v-list-item {
		padding: 0 11px;
		min-height: 30px;
	}
}

::v-deep(.v-menu__content) {
}
</style>
